import * as React from 'react';

const Rendered = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      style={{
        padding: 14,
        backgroundColor: 'var(--cds-color-darken-50)',
        borderRadius: 4,
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      {children}
    </div>
  );
};

export default Rendered;
